<div class="w-100 d-flex flex-wrap surface-elevated align-content-flex-start container">
  <ngx-app-bar
    class="w-100"
    [title]="'ورود اطلاعات'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  @if (isLoading()) {
    <app-spinner />
  } @else {
    <div
      class="w-100 d-flex flex-wrap px-plus mt-big content-container"
      [formGroup]="form"
    >
      <p class="b-2 text-onback-high">یک شماره شبا متعلق به کد ملی {{ state().nationalId }} را وارد کنید.</p>
      <ui-form-field
        class="w-100 mt-medium h-100 pl-4"
        [errorMessageMapper]="{
          pattern: 'شماره شبا نادرست است',
          invalidIban: 'شماره شبا نادرست است',
          serverError: parentErrors()['iban'],
        }"
        [error]="form.controls['iban'].errors"
        [type]="'iban'"
        formControlName="iban"
      ></ui-form-field>

      <div class="w-100 button-container">
        <ngx-button
          buttonId="WALLET_CONFIRM_IBAN"
          [style]="'fill'"
          size="large"
          [fullWidth]="true"
          (clickHandler)="checkSejam()"
          [disabled]="form.invalid || checkSejamLoading()"
          [isLoading]="checkSejamLoading()"
        >
          تایید و ادامه
        </ngx-button>
      </div>
    </div>
  }
</div>
